import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ProductVariantOptionService } from './product-variant-option.service';
import { ProductVariantOptionModel } from './product-variant-option.model';
import { map } from 'rxjs';

export const ProductVariantOptionResolver: ResolveFn<ProductVariantOptionModel> = (route, state) => {
  return inject(ProductVariantOptionService).getById(route.paramMap.get('id')!).pipe(
    map(response => response.data)
  );
};
